import { PropsWithChildren } from 'react'

export function CategoryContainer({ children }: PropsWithChildren) {
  return (
    <li className='group relative flex h-[200px] w-full items-end lg:h-[256px]'>
      {children}
    </li>
  )
}
